/* eslint-disable no-return-assign */
import React from 'react';
import PropTypes from 'prop-types';

const getStartingRotation = noOfLetters => {
  let value;
  if (noOfLetters === 12 || noOfLetters === 11 || noOfLetters === 10) {
    value = -53;
  } else if (
    noOfLetters === 9 ||
    noOfLetters === 8 ||
    noOfLetters === 7 ||
    noOfLetters === 6
  ) {
    value = -51;
  } else if (noOfLetters === 5) {
    value = -47;
  } else if (noOfLetters === 4) {
    value = -44;
  } else if (noOfLetters === 3) {
    value = -40;
  } else if (noOfLetters === 2) {
    value = -31;
  } else if (noOfLetters === 1) {
    value = 0;
  } else if (noOfLetters > 7) {
    value = -55;
  }
  return value;
};

const CurvedText = ({ text, radius }) => {
  const splitText = text.split('');
  const deg = 110 / splitText.length;
  let origin = getStartingRotation(splitText.length);
  return splitText.map((letter, i) => (
    <p
      style={{
        height: `${radius}px`,
        position: 'absolute',
        transform: `rotate(${i === 0 ? origin : (origin += deg)}deg)`,
        transformOrigin: '0 100%'
      }}
    >
      {letter}
    </p>
  ));
};

CurvedText.propTypes = {
  text: PropTypes.string,
  radius: PropTypes.number
};

export default CurvedText;
